import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { PasswordEyeIcon } from '../../svg/';
import { Row } from '../../layout/flex';
import styled from '../../../styles/styled';
import AppText from '../../typography/app_text';
export const RoundedInput = ({ name, error, placeholder, label, hideLabel = !label, disabled, ...rest }) => {
    const [showInput, setShowInput] = useState(name !== 'password');
    return (_jsxs(RoundedDiv, { error: !!error, disabled: disabled, children: [_jsxs(Row, { children: [_jsx(Input, { ...rest, id: name, disabled: disabled, type: showInput ? 'text' : 'password', placeholder: placeholder ?? ' ' }), !hideLabel && _jsx(InputLabel, { htmlFor: name, children: label }), name === 'password' && (_jsx(PasswordEyeIcon, { onClick: () => setShowInput(!showInput), height: "25%", width: "50px", style: {
                            position: 'absolute',
                            right: 0,
                            top: '33%',
                            stroke: showInput ? undefined : 'gray',
                            transition: 'stroke 0.2s',
                        } }))] }), _jsx(InputError, { children: error })] }));
};
const floatingLabel = {
    'label, input': {
        transition: 'all 0.2s',
    },
    // Regular (non-floating) styles
    'input:placeholder-shown + label': {
        cursor: 'text',
        whiteSpace: 'nowrap',
        transformOrigin: 'left bottom',
        transform: 'translate(0, 0) scale(1)',
    },
    // Floating styles
    'input:not(:placeholder-shown) + label': {
        transform: 'translate(0, 1.125rem) scale(1.5)',
        cursor: 'pointer',
    },
    'input:focus + label': {
        transform: 'translate(0, 0) scale(1)',
        cursor: 'pointer',
    },
};
const RoundedDiv = styled.div(props => ({
    position: 'relative',
    display: 'flex',
    flex: 1,
    border: props.error ? '2px solid #ff0000' : '2px solid #2C2C2C',
    borderRadius: 2,
    padding: 5,
    margin: 5,
    flexDirection: 'column',
    transition: ['border 0.2s', 'background-color 0.2s'],
    backgroundColor: props.disabled ? props.theme.colors.grey10 : undefined,
    ...floatingLabel,
}));
const Input = styled.input({
    flex: 1,
    border: 0,
    height: 50,
    outline: 'none',
}, ({ theme, disabled }) => ({
    background: theme.colors.white,
    fontFamily: theme.text.bodyFontFamily,
    fontSize: theme.text.size.medium,
    color: theme.colors.grey90,
    transition: 'background-color 0.2s',
    backgroundColor: disabled ? theme.colors.grey10 : undefined,
}));
const InputLabel = styled.label({
    position: 'absolute',
    textTransform: 'capitalize',
}, ({ theme }) => ({
    fontFamily: theme.text.headingFontFamily,
    fontSize: theme.text.size.small,
    color: theme.colors.grey30,
}));
const InputError = styled(AppText)({
    color: 'red',
    margin: 0,
    textTransform: 'capitalize',
});
//# sourceMappingURL=rounded_input.js.map